import React, { useEffect } from 'react';
import { CmsSsrComponentProps } from '@/types/cms';
import Container from '../Container';
import DataSourceEmpty from '../DataSourceEmpty';
import ProductSingle from './product-single';
import ProductTwo from './product-two';
import ProductThree from './product-three';
import ProductFour from './product-four';
import Swiper, { SwiperSlide } from '@/components/common/Swiper';
import { twMerge } from 'tailwind-merge';
import ProductCard from '@/components/common/ProductCard/VerticalItemLine';
import { AddToCartReferType } from '@/constants/track';
import { getDeliveryDate } from '@/utils/common/porder';
import { getStaticResData } from '../../tools';

const FeaturedProduct: React.FC<CmsSsrComponentProps> = props => {
  const {
    componentKey,
    componentInstanceKey,
    componentPosition,
    properties,
    trackingContext,
    staticRes,
    top,
    onDataSourceError,
    isPreview
  } = props;
  const { result, object } = getStaticResData(staticRes);
  const { products } = (object as { products: ProductType[] }) ?? { products: [] };
  const eventKey = properties?.event_key || componentKey;

  const noData = !result || !Array.isArray(products) || products.length === 0;

  useEffect(() => {
    if (noData) {
      onDataSourceError?.();
    }
  }, [noData, onDataSourceError]);

  if (noData) {
    return (
      <DataSourceEmpty componentInstanceKey={componentInstanceKey} componentKey={componentKey}>
        <div className="h-5" />
      </DataSourceEmpty>
    );
  }

  const productCount = products?.length;

  return (
    <Container
      componentKey={componentKey}
      componentInstanceKey={componentInstanceKey}
      properties={properties}
      top={top}>
      {productCount === 1 && (
        <ProductSingle
          data={products[0]}
          properties={properties}
          eventKey={eventKey}
          position={componentPosition}
          trackingContext={trackingContext}
          isPreview={isPreview}
        />
      )}
      {productCount === 2 && (
        <ProductTwo
          data={products}
          properties={properties}
          eventKey={eventKey}
          position={componentPosition}
          trackingContext={trackingContext}
          isPreview={isPreview}
        />
      )}
      {productCount === 3 && (
        <ProductThree
          data={products}
          properties={properties}
          eventKey={eventKey}
          position={componentPosition}
          trackingContext={trackingContext}
          isPreview={isPreview}
        />
      )}
      {productCount === 4 && (
        <ProductFour
          data={products}
          properties={properties}
          eventKey={eventKey}
          position={componentPosition}
          trackingContext={trackingContext}
          isPreview={isPreview}
        />
      )}
      {productCount > 4 && (
        <div className="pt-2 pb-10">
          <Swiper
            slidesPerView="auto"
            freeMode
            spaceBetween={4}
            slidesOffsetAfter={10}
            slidesOffsetBefore={10}
            lazy
            className="items-stretch">
            {!!products?.length &&
              products?.map((item, index) => {
                return (
                  <SwiperSlide
                    key={`${item.id}-${index}`}
                    className={twMerge('!w-[150px] flex-none !h-auto flex items-stretch')}>
                    <ProductCard
                      addCartParams={{
                        referType: AddToCartReferType.normal,
                        deliveryDate: getDeliveryDate()
                      }}
                      positionInfoT2={{
                        modSecPos: {
                          mod_nm: eventKey,
                          mod_pos: componentPosition
                        },
                        prodPos: index,
                        context: {
                          tag_key: item?.entrance_tag?.tag_key,
                          tag_name: item?.entrance_tag?.tag_name,
                          ...trackingContext
                        }
                      }}
                      data={item}
                      showAddBtn={!isPreview}
                    />
                  </SwiperSlide>
                );
              })}
          </Swiper>
        </div>
      )}
    </Container>
  );
};

export default FeaturedProduct;
